
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateMeetingTemplateAgendaItemDtoFormGroup() {
return new FormGroup({
    meetingTypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
    title: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    description: new FormControl<string | undefined>(''),
    sortableRank: new FormControl<number | undefined>(undefined, [Validators.min(0)]),
})
;
}
      